/**
 * SignupPage - Full signup page
 */

import { AuthLayout } from '../components/AuthLayout';
import { SignupForm } from '../components/SignupForm';

export function SignupPage() {
  return (
    <AuthLayout
      title="Create Account"
      subtitle="Start monitoring your air quality today"
    >
      <SignupForm />
    </AuthLayout>
  );
}
